import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { filter, take, takeUntil, withLatestFrom } from 'rxjs/operators';
import { selectHasPositionLotsPhase2 } from '../../../authorize/reducers';
import { FeatureFlagService } from '../../../shared/services/feature-flag-service';
import { TrustTaxCategory } from '../../../shared/types/TrustTaxCategory';
import { transactionTypes } from '../../../shared/utilities/Constants';
import { AchTransactionDetailsForm, CheckTransactionDetailsForm, ItTransactionDetailsForm, WireTransactionDetailsForm } from '../../models/form/TransactionFormGroup';
import { OptionDropdown, SelectControl } from '../../models/OptionDropdownSelect';
import { selectIsFromEdit, selectToAccountsInfo, selectTransactionType } from '../../reducers';
import { createControl } from '../../utilities/formUtilities';

@Component({
  standalone: false,
  selector: 'mm-trust-tax-category',
  templateUrl: './trust-tax-category.component.html',
  styleUrls: ['./trust-tax-category.component.scss']
})
export class TrustTaxCategoryComponent implements OnInit, OnDestroy {
  @Input() parentForm: FormGroup<CheckTransactionDetailsForm | WireTransactionDetailsForm | ItTransactionDetailsForm | AchTransactionDetailsForm>;
  @Input() taxCategories: Observable<TrustTaxCategory[]>;
  private controlName = 'trustTaxCategory';
  positionLotsPhase2EnabledFsg: boolean = false;
  taxCategoryDropdownModel: SelectControl = {
    controlName: this.controlName,
    title: 'Trust tax category',
    validationMessage: 'Trust tax category needs to be selected',
    options: []
  };
  private destroy$ = new Subject<void>();
  isFromEdit: boolean = false;

  constructor(private store: Store, private featureFlagService: FeatureFlagService) { }

  ngOnInit(): void {
    this.store.select(selectHasPositionLotsPhase2).pipe(takeUntil(this.destroy$)).subscribe(val => {
      this.positionLotsPhase2EnabledFsg = val;
    });
    this.store.select(selectIsFromEdit).pipe(takeUntil(this.destroy$)).subscribe(val => {
      this.isFromEdit = val;
    });

    if (this.positionLotsPhase2Enabled() && !this.isFromEdit) {
      this.store
        .pipe(
          select(selectToAccountsInfo),
          takeUntil(this.destroy$),
          withLatestFrom(selectTransactionType),
          filter((txnType) => { 
            return txnType === transactionTypes.internalTransfer 
          })
        )
        .subscribe((toAccounts) => {
          let numToAccounts = Object.keys(toAccounts).length;
          if (numToAccounts === 0) {
            this.taxCategoryControl?.setValue('', { emitEvent: false });
          }
        });
    }

    createControl(this.parentForm, this.controlName, '', [Validators.required])
  
    this.taxCategories.pipe(
      take(1),
    ).subscribe((categories) => {
      this.taxCategoryDropdownModel.options = categories.map(category => new OptionDropdown(category, category.toUpperCase()));
    });
  }

  ngOnDestroy(): void {
    this.parentForm?.removeControl('trustTaxCategory');

    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  positionLotsPhase2Enabled(): boolean {
    return this.featureFlagService.featureFlags.positionLotsPhase2Enabled || this.positionLotsPhase2EnabledFsg;
  }

  get taxCategoryControl(): FormControl<string> | undefined {
    return this.parentForm?.get(this.controlName) as FormControl<string>;
  }

}
